import { fn } from "core/util";

import createModel from "../createModel";

export const ConsentItem = createModel("ConsentItem", (json) => ({
    consentEntity: json.ConsentEntity,
    consentReason: json.ConsentReason,
    isActive: fn.parseBoolean(json.IsActive),
}));
